import { Model as BaseModel, type HTTPRequestConfig, type HTTPPromise } from 'vue-api-query';
import { useRuntimeConfig } from '#imports'; // makes TS aware of the Nuxt helper
import { useForm } from '~/utils/useForm';

export default class Model extends BaseModel {
  override baseURL(): string {
    return useRuntimeConfig().public.apiBase + "/api/v2" // or hardcode your API root
  }
  override request(config: HTTPRequestConfig): HTTPPromise {
    return Model.$http.request(config)
  }
  
  /*
  _applyInstanceCollection(data, model = this.constructor) {
    let collection = data.data || data
    collection = Array.isArray(collection) ? collection : [collection]

    collection = collection.map((c) => {
      return this._applyInstance(c, model)
    })
    return collection
  }

  _applyRelations(model) {
    const relations = model.relations()

    for (const relation of Object.keys(relations)) {
      const _relation = model[relation];
      // const _relation = getProp(model, relation)

      if (!_relation) {
        continue
      }

      if (Array.isArray(_relation.data) || Array.isArray(_relation)) {
        const collection = this._applyInstanceCollection(
          _relation,
          relations[relation]
        )

        if (_relation.data !== undefined) {
          _relation.data = collection
        } else {
          model[relation] = collection;
          // setProp(model, relation, collection)
        }
      } else {
        model[relation] = this._applyInstance(_relation, relations[relation]);
        // setProp(model, relation, this._applyInstance(_relation, relations[relation]))
      }
    }
  }
  _unwrap(response) {
    if (this._wrapper) {
      return response[this._wrapper] || response
    } else {
      return response
    }
  }
  
  get() {
    let base = this._fromResource || `${this.baseURL()}/${this.resource()}`
    base = this._customResource
      ? `${this.baseURL()}/${this._customResource}`
      : base
    let url = `${base}${this._builder.query()}`

    return this.request(
      this._reqConfig({
        url,
        method: 'GET'
      })
    ).then((response) => {
      let collection = this._applyInstanceCollection(response.data)

      if (response.data.data !== undefined) {
        response.data.data = collection
      } else {
        response.data = collection
      }

      return this._unwrap(response.data)
    })
  }
    */
   
  // Helpers
  updateRelatedData(model: Record<string, unknown>, myKey: string, matchFn: (item: unknown) => boolean) {
    const related = (this as Record<string, unknown>)[myKey];
    if (!Array.isArray(related)) {
      return;
    }

    const dataIndex = related.findIndex(matchFn);
    if (dataIndex === -1) {
      related.push(model);
    } else {
      related.splice(dataIndex, 1, model);
    }
  }

  removeRelatedData(model: Record<string, unknown>, myKey: string, matchFn: (item: unknown) => boolean) {
    const related = (this as Record<string, unknown>)[myKey];
    if (!Array.isArray(related)) {
      return;
    }

    const dataIndex = related.findIndex(matchFn);
    if (dataIndex !== -1) {
      related.splice(dataIndex, 1);
    }
  }

  toForm() {
    return new useForm(this, { useResource: this, resetOnSuccess: !(this as Record<string, unknown>)[this.primaryKey()] });
  }
}
